import { render } from "./PassTypeSetting.vue?vue&type=template&id=1981b1bc&scoped=true"
import script from "./PassTypeSetting.vue?vue&type=script&lang=js"
export * from "./PassTypeSetting.vue?vue&type=script&lang=js"

import "./PassTypeSetting.vue?vue&type=style&index=0&id=1981b1bc&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1981b1bc"]])

export default __exports__